import React, { useEffect } from 'react';
import Input from '../../Inputs/Input';
import {
  PRODUCT_DETAIL_LIST_COL_SIZE_LIST,
  StockStatusLevel,
} from '../../../constants';
import BuyButton from '../../BuyButton/BuyButton';
import Product from '../../../Types/Product';
import { translate } from '../../../Services/translation';
import clsx from 'clsx';
import FavoriteButton from '../../FavoriteButton/FavoriteButton';
import DetailedListFavoriteButton from './DetailedListFavoriteButton';

interface DetailedListBuyFormProps {
  quantity: number;
  product: Product;
  boxesAmount: number;
  rollsAmount: number;
  totalAmount: number;
  packageSize: number;
  setBoxesAmount: (boxesAmount: number | undefined) => void;
  setRollsAmount: (rollsAmount: number | undefined) => void;
  setTotalAmount: (totalAmount: number | undefined) => void;
  setQuantity: (quantity: number) => void;
  isProductPage?: boolean;
}
const DetailedListBuyForm = ({
  isProductPage = false,
  quantity,
  product,
  boxesAmount,
  rollsAmount,
  totalAmount,
  setTotalAmount,
  packageSize,
  setBoxesAmount,
  setRollsAmount,
  setQuantity,
}: DetailedListBuyFormProps) => {
  const getParsedValue = (value: string) => {
    return parseFloat(value) >= 0
      ? parseFloat(value)
      : value != ''
      ? 0
      : undefined;
  };
  useEffect(() => {
    // if value of boxes is changed but boxes and rolls amount are 0 or empty - Clear total amount and set it to 0
    if (
      !boxesAmount &&
      boxesAmount == 0 &&
      !rollsAmount &&
      rollsAmount == 0
    ) {
      setTotalAmount(0);
      return;
    }
    //if boxes amount is changed and is is empty but rolls amount have a value. Set total amount to rolls amount
    if (!boxesAmount && boxesAmount == 0) {
      setTotalAmount(rollsAmount);
      return;
    }
    if (boxesAmount && boxesAmount > 0) {
      if (!rollsAmount && rollsAmount == 0) {
        setTotalAmount(boxesAmount * packageSize);
        return;
      } else {
        setTotalAmount(boxesAmount * packageSize + rollsAmount);
      }
    }
  }, [boxesAmount]);
  useEffect(() => {
    // if value of rolls is changed but boxes and rolls amount are 0 or empty - Clear total amount and set it to 0
    if (
      !boxesAmount &&
      boxesAmount == 0 &&
      !rollsAmount &&
      rollsAmount == 0
    ) {
      setTotalAmount(0);
      return;
    }
    //if rolls amount is changed and is is empty but boxes amount have a value. Set total amount to boxes amount
    if (!rollsAmount && rollsAmount == 0) {
      setTotalAmount(boxesAmount * packageSize);
      return;
    }
    if (rollsAmount && rollsAmount > 0) {
      if (!boxesAmount && boxesAmount == 0) {
        setTotalAmount(rollsAmount);
        return;
      } else {
        setTotalAmount(boxesAmount * packageSize + rollsAmount);
      }
    }
  }, [rollsAmount]);
  useEffect(() => {
    if (!totalAmount || totalAmount == 0) {
      setBoxesAmount(0);
      setRollsAmount(0);
    }
    if (totalAmount && totalAmount > 0) {
      setQuantity(totalAmount);
      if (totalAmount < packageSize) {
        setBoxesAmount(0);
        setRollsAmount(totalAmount);
      } else {
        setBoxesAmount(Math.floor(totalAmount / packageSize));
        setRollsAmount(totalAmount % packageSize);
      }
    }
    setQuantity(totalAmount && totalAmount > 0 ? totalAmount : 0);
  }, [totalAmount]);
  return (
    <>
      {packageSize && packageSize > 1 ? (
        <>
          <div
            className="flex h-full flex-col self-center md-down:!w-[unset]"
            style={{
              width: !isProductPage
                ? `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[6]}%`
                : undefined,
            }}
          >
            <div
              className={clsx(
                'text-md font-bold ',
                !isProductPage && 'lg:hidden'
              )}
            >
              {translate('detailed-product-card.boxes')}
            </div>
            <Input
              value={!!boxesAmount ? boxesAmount : ''}
              onChange={(e) =>
                setBoxesAmount(getParsedValue(e.target.value))
              }
              type="number"
            />
          </div>
          <div
            className="flex h-full flex-col self-center md-down:!w-[unset]"
            style={{
              width: !isProductPage
                ? `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[7]}%`
                : undefined,
            }}
          >
            <div
              className={clsx(
                'text-md font-bold ',
                !isProductPage && 'lg:hidden'
              )}
            >
              {translate('detailed-product-card.rolls')}
            </div>
            <Input
              value={!!rollsAmount ? rollsAmount : ''}
              onChange={(e) =>
                setRollsAmount(getParsedValue(e.target.value))
              }
              type="number"
            />
          </div>
        </>
      ) : (
        !isProductPage && (
          <>
            <div
              className="flex h-full flex-col self-center md-down:!w-[unset]"
              style={{
                width: !isProductPage
                  ? `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[6]}%`
                  : undefined,
              }}
            ></div>
            <div
              className="flex h-full flex-col self-center md-down:!w-[unset]"
              style={{
                width: !isProductPage
                  ? `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[7]}%`
                  : undefined,
              }}
            ></div>
          </>
        )
      )}
      <div
        className={clsx(
          'flex h-full flex-col self-center md-down:!w-[unset]'
        )}
        style={{
          width: !isProductPage
            ? `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[8]}%`
            : undefined,
        }}
      >
        {!product.isMeasuredWallpaper && (
          <>
            <div
              className={clsx(
                'text-md font-bold ',
                !isProductPage && 'lg:hidden'
              )}
            >
              {translate('detailed-product-card.total')}
            </div>
            <Input
              value={!!totalAmount ? totalAmount : ''}
              onChange={(e) =>
                setTotalAmount(getParsedValue(e.target.value))
              }
              type="number"
            />
          </>
        )}
      </div>
      <div
        className={clsx(
          'flex h-full self-center md-down:!w-[unset]',
          !isProductPage ? 'lg:gap-3 md-down:flex-col' : 'flex-col',
          isProductPage &&
            (!packageSize || packageSize <= 1) &&
            'col-span-2 sm:col-span-3'
        )}
        style={{
          width: !isProductPage
            ? `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[9]}%`
            : undefined,
        }}
      >
        {/* Empty column */}
        <div
          className={clsx(
            'h-[21px] text-md font-bold',
            !isProductPage && 'lg:hidden lg:gap-3',
            isProductPage && packageSize > 1 && 'hidden sm:block'
          )}
        >
          {' '}
        </div>
        {product.stockStatus?.level !== StockStatusLevel.Inactive &&
          !product.disableBuyOption && (
            <>
              {!product.isMeasuredWallpaper ? (
                <BuyButton
                  articleNumber={product.id}
                  quantity={quantity}
                  hideIcon={true}
                  btnSize={'medium'}
                  disabled={
                    (product.stockStatus &&
                      !product.stockStatus.inStock) ||
                    !quantity ||
                    !product.id
                  }
                />
              ) : (
                <a
                  className="btn btn--outlined btn--medium relative w-full border-gray-700"
                  href={product.url}
                >
                  {translate('product-card.view')}
                </a>
              )}
            </>
          )}
        {!isProductPage && (
          <DetailedListFavoriteButton
            className="md-down:hidden"
            product={product}
          />
        )}
      </div>
    </>
  );
};

export default DetailedListBuyForm;
